<template>
	<div class="box-tips" v-show="pageShow">
		<template v-if="exam_pass">
			<img src="@/assets/tips/success.png" class="success-img" />
		</template>
		<template v-else>
			<img src="@/assets/tips/fail.png" class="success-img" />
			<span class="tips-text">{{ msg }}</span>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		mode: {
			type: String,
			default: 'exam'
		}
	},
	data() {
		return {
			pageShow: false,
			exam_pass: '',
			msg: ''
		};
	},
	created() {
		if (!this.$store.getters.getToken) {
			this.navToForbidden();
		} else {
			this.service2('client/order/tips_text', { mode: this.mode, orderid: this.$route.query.orderid }).then(res => {
				this.exam_pass = res.data.exam_pass == 1;
				this.msg = res.data.msg;
				this.pageShow = true;
			});
		}
	},
	methods: {
		navToForbidden() {
			this.$router.replace({
				path: '/' + this.mode + '/login'
			});
		}
	}
};
</script>

<style scoped>
.box-tips {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding-top: 2.125rem;
	box-sizing: border-box;
}
.success-img {
	width: 7.5rem;
}
.tips-text {
	margin-top: 0.625rem;
	font-size: 0.44rem;
	font-weight: 500;
	color: #292b3c;
	padding: 0 0.8rem;
	box-sizing: border-box;
}
</style>
